export const ADD_COMMAND = 'add'
export const CREATE_COMMAND = 'create'
export const DEFAULT_DATABASE_PLAN = 'free_v3'
export const GENERATE_COMMAND = 'generate'
export const INIT_COMMAND = 'init'
export const REMOVE_COMMAND = 'remove'
export const REMOVE_SCHEMA_COMMAND = 'remove-schema'
export const UPDATE_COMMAND = 'update'
export const ALL_FLAG = '--all'
export const CANCELLED = Symbol('cancelled')
export const CREATE_SCHEMA_KINDS = ['entity', 'single', 'form'] as const
